import {useState, useCallback, useEffect, Fragment} from "react";

import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid2'
import SsidChartIcon from '@mui/icons-material/SsidChart';
import MapIcon from '@mui/icons-material/Map';

import useAuthenticatedRequest from "../../../lib/useAuthenticatedRequest";
import { BreadCrumbsCustom } from "../../../components/BreadCrumbsCustom";
import { ModalCustom } from "../../../components/ModalCustom";
import { PaperChartCustom } from "../../../Theme/ContainerStyle";
import DashboardBody from "../DashboardMain/DashboardBody";
import IndexLine from "./GraphicLine/IndexLine";


////SI PORTA DIETRO SITE(site, id, brand) E VARIABLELIST[{variable, color}]
/// FA UNA CHIAMATA({chartDataResponse,isLoading}, triggerRequest)
///RISTRUTTURA VARIBLESLIST INSERENDOLO IN VARIABLES PER INSERIRCI VARIABLE E COLOR
///SEARCH è UNA FUNZIONE PER SETTARE DATA IN BASE ALLE DATE ED I SELEZIONATI
////QUESTO COMPONENTE E' L'UNIONE DI 4 COMPONENTI:EnergyChart(il grafico), 
///AccordionWrapper(le variabili da selezionare), DashboardFooter(il footer), 
///PeriodPicker(un Dialog che è una specie di modale, per selezionare il periodo da visualizzare)
export default function HACCP(props) {

  const {site, RouterLink, SITES_ROUTE, SITE_ROUTE, data} = props;

  // const [{isLoading: dataLoading, data: chartDataResponse},triggerRequest,] = useAuthenticatedRequest();
  const [{data: mapData},] = useAuthenticatedRequest({
    method: "POST",
    url: "get-contents",
    data: {
      siteID: Number(site.id),
      categoryID: 0, //0 -> HACCP
      contentKey: "mappa"
    }
  });

  const [switchCase, setSwitchCase] = useState("0");
  const [openMap, setOpenMap] = useState(false)
  const [openMapModal, setOpenMapModal] = useState(false)
  const [mapRender, setMapRender] = useState();

  ////RENDER DEL GRAFICO IN BASE AL PULSANTE PREMUTO DETERMIATO DALL'ID SWITCHCASE
  const renderContent = () => {
    switch (switchCase) {
      case "0":
        return <IndexLine {...props} openMap={openMap} mapExist={mapRender}/>; 
      default:
        return null; 
    }
  };
  ///DETERMINA GLI ID E LE ICONE DELLA BARRA STACK
  const configStack = [
    {value:"0", title:"Grafico a linee",icon:<SsidChartIcon/>},
  ]

  const configBradCrumbs = {
    Component:BreadCrumbsCustom,
    generalConfig:{
      RouterLink:RouterLink,
      typographyText:data.category.name,
      linkConfig:[
        {
          to:SITES_ROUTE.path,
          textLink:"Home",
        },
        {
          to:SITE_ROUTE.computePath({siteId: data.site.id}),
          textLink:data.site.brand + " - " + data.site.name,
        },
      ]
    },
  }

  // Funzione per controllare e impostare la disponibilità della mappa
  const updateMapRender = useCallback((mapData) => {
    if (mapData && mapData.contents) {
      const { contentPath } = mapData.contents.find(({ contentKey }) => contentKey === "mappa") || {};
      const isMapAvailable = contentPath && !contentPath.includes("default");
      setMapRender(isMapAvailable);
    } else {
      setMapRender(false); 
    }
  }, []);

  useEffect(() => {
    updateMapRender(mapData);
  }, [mapData, updateMapRender]);

  const renderMap = () => {
    const handleMap = () => {
      if (mapRender) {
        setOpenMap(!openMap)
      }
    };

    return (
      <ToggleButtonGroup onChange={handleMap}>
        <ToggleButton value="center" className="site-map">
          <Tooltip title={mapRender ? "Mappa" : "Mappa non disponibile"}>
            <MapIcon/>
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    )
  }

  const renderBody = () => {
    const gridsize = openMap && mapRender ? 8 : 12
    
    const ImageMap = () => {
      const handleModalMap = () => {
        setOpenMapModal(true)
      };
      const REACT_APP_CLOUD_CONTROL_BASE_PATH = process.env.REACT_APP_CLOUD_CONTROL_BASE_PATH;
      const {contentPath} = mapData.contents.find(({contentKey}) => contentKey === "mappa");
  
      return (
        <img src={`${REACT_APP_CLOUD_CONTROL_BASE_PATH}${contentPath}`} alt="Mappa non presente" width="100%" onClick={handleModalMap} />
      )
    }

    return (
      <Fragment>
        <Grid  item size={{xs:12, md:gridsize, lg:gridsize}}>
          {/* {dataLoading && mapLoading && (<LinearProgress />)} */}
          {renderContent()}
        </Grid>
        {openMap && mapRender && <Grid item size={{xs:12, md:4, lg:4}}>
          <PaperChartCustom className="site-map-visual">
            <ImageMap/> 
          </PaperChartCustom>
          <ModalCustom  
                open={openMapModal}
                onClose={() => {setOpenMapModal(false)}} 
                confirm={false}
                sxStyle={{width: { xs: "100%", sm: "50%"}}}>
            <ImageMap/>  
          </ModalCustom>
        </Grid>}
      </Fragment>
    )
  }

  const propsDashboardBody = 
  {configBradCrumbs, configStack,    
    switchCase, setSwitchCase, renderMap}
    
  return (
    <DashboardBody {...propsDashboardBody}>
      {renderBody()}
    </DashboardBody>
  );
}
